module.exports = __webpack_public_path__ + "img/card-top-bg.0fece42c.png";